import { useTranslation } from 'react-i18next';

import { ICreatePasswordForm } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';

import { createPasswordSchema } from './createPasswordSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: ICreatePasswordForm) => void;
  modalInfo: { title: string; submitBtnLabel: string };
}

const CreatePasswordFormView = ({ isOpen, onClose, onSubmit, modalInfo }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<ICreatePasswordForm>
      isOpen={isOpen}
      onClose={onClose}
      title={modalInfo.title}
      submitBtnLabel={modalInfo.submitBtnLabel}
      defaultValues={{ password: '', confirmPassword: '' }}
      onSubmit={onSubmit}
      schema={createPasswordSchema()}
    >
      <Field
        name="password"
        label={t('labelPassword')}
        type={InputType.PASSWORD}
        inputProps={{
          size: Size.LG,
          autoFcous: true,
        }}
      />
      <Field
        name="confirmPassword"
        label={t('labelConfirmPassword')}
        type={InputType.PASSWORD}
        inputProps={{
          size: Size.LG,
        }}
      />
    </Form>
  );
};

export default CreatePasswordFormView;
